module.exports = require('./icon');
